module.exports = __webpack_public_path__ + "media/ticket_call.9c37bae3.mp3";